export default function (value) {
  let result = (value / 60).toFixed(2) + '';
  let min = 0;
  let sec = 0;

  result = result.split('.');
  min = result[0]; // высчитываем минуты
  sec = ((result[1] / 100) * 60).toFixed(0); // высчитываем оставшиеся секунды

  if (min < 10) {
    min = '0' + min; // красивости
  }
  if (sec < 10) {
    sec = '0' + sec; // красивости
  }
  result = min + ':' + sec;
  return result;
}
